import { endPoints } from 'config/routes';
import { redirectTo } from 'libs/common';

export default function Default() {
  redirectTo(endPoints.accountSetting);
  return null;
}



// WEBPACK FOOTER //
// ./src/views/Default/Default.jsx